import { fadeInFromRight } from "@components/pages/start-profiting/StartProfitingPage/styles";
import { keyframes, styled } from "@styles";
import { X as IconX } from "react-feather";

export const AnimationWrapper = styled("div", {
  position: "relative",
  width: "$24px",
  height: "$24px",
});

const impact = keyframes({
  "0%": {
    opacity: 0,
  },

  "25%": {
    opacity: 1,
  },

  "100%": {
    opacity: 0,
    width: "$18px",
    height: "$18px",
    borderWidth: "$3px",
  },
});

export const Impact = styled("div", {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "$14px",
  height: "$14px",
  borderRadius: "50%",
  backgroundColor: "$neutral00",
  borderWidth: "$2px",
  borderStyle: "solid",
  borderColor: "$primary-opaque",
  animation: `${impact} 900ms ease-out infinite`,
});

const pulse = keyframes({
  "0%": {
    width: "$10px",
    height: "$10px",
  },

  "25%": {
    width: "$6px",
    height: "$6px",
  },

  "70%": {
    width: "$6px",
    height: "$6px",
  },

  "100%": {
    width: "$10px",
    height: "$10px",
  },
});

export const Pulse = styled("div", {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "$6px",
  height: "$6px",
  borderRadius: "50%",
  backgroundColor: "$primary",
  animation: `${pulse} 1200ms ease-out infinite`,
});

export const Container = styled("div", {
  display: "flex",
  width: "26.25rem",
  borderRadius: "$sm",
  borderLeft: "8px solid",
  boxShadow: "0px 0px 24px rgba(0, 0, 0, 0.12)",
  backgroundColor: "$neutral00",

  animation: `${fadeInFromRight} 0.5s ease-in-out`,

  "@sm": {
    width: "100%",
  },

  variants: {
    type: {
      success: {
        borderColor: "$green20",
        [`${Impact}`]: {
          borderColor: "$green20",
        },
        [`${Pulse}`]: {
          backgroundColor: "$green40",
        },
      },
      error: {
        borderColor: "$red20",
        [`${Impact}`]: {
          borderColor: "$red20",
        },
        [`${Pulse}`]: {
          backgroundColor: "$red40",
        },
      },
      info: {
        borderColor: "$blue20",
        [`${Impact}`]: {
          borderColor: "$blue20",
        },
        [`${Pulse}`]: {
          backgroundColor: "$blue40",
        },
      },
    },
  },
});

export const Title = styled("div", {
  display: "flex",
  alignItems: "center",
  fontSize: "$md",
  fontWeight: "$bold",
  lineHeight: "$150",
  color: "$neutral100",

  // lobotomized owl hack (*+*), because the 'gap' property does not work from safari 14 and below
  "> * + *": {
    marginLeft: "$8px",
  },
});

export const Body = styled("div", {
  width: "100%",
  padding: "$16px 0 $16px $16px",
  fontSize: "$sm",
  fontWeight: "$regular",
  lineHeight: "$171",
  color: "$neutral80",

  ".bannedAccount": {
    textDecoration: "none",
    marginLeft: "$20px",
    color: "$blue40",

    "&:hover": {
      color: "$blue70",
    },
  },
});

export const Close = styled(IconX, {
  width: "$24px",
  height: "$24px",
  margin: "$16px $24px $16px $12px",
  color: "$neutral100",
  cursor: "pointer",
});
